import React, { useState, useReducer } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CInvalidFeedback
} from '@coreui/react'
import CIcon from '@coreui/icons-react';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { schema, forgotPasswordSchema, updatePasswordSchema } from './../../../form_validation/login/otherRoles';
import { FingerPrintDefaultIcon } from './../../../assets/svg_icons/index'
import { loginWithCredentials, forgotPassword, updatePassword, loginCredentials, loginwithGmail } from './../../../utils/api';
import { saveToken, saveLoggedInUserDetails, getToken, saveCompanyDetails, saveProfileImageUrl, saveVersion, getVersion } from './../../../utils/auth';
import { Redirect } from 'react-router-dom'
import DisplayAlert from '../../../components/DisplayAlert';
import Loader from './../../../components/Loader';
import yolo_logo from './../../../assets/img/yolohealth.png'
import { GoogleLogin } from 'react-google-login';
import { VERSION } from 'src/config/app';


const reduce = ((state, action) => {

  switch (action.type) {

    case 'logged_in':
      return { ...state, isLoggedIn: true, serverResponseStatus: action.payload };
    case 'forgot_password_email_sent':
      return { ...state, forgotEmailSent: true, loading: false, email: action.payload };
    case 'update_password':
      return { ...state, forgotEmailSent: false, loading: false, showPasswordModal: false, serverResponseStatus: action.payload };
    case 'api_called':
      return { ...state, loading: action.payload, serverResponseStatus: action.payload }
    case 'api_error':
      return { ...state, loading: false, serverResponseStatus: action.payload }
    case 'password_modal':
      return { ...state, showPasswordModal: action.payload }
    default:
      return state;
  }
})

const Login = () => {
  const gmail_client_id = process.env.REACT_APP_GMAIL_CLIENT_ID
  const [modal, setModal] = useState(false)
  // const [loading, setLoading] = React.useState(false);
  // const [isLoggedIn, setLoggedIn] = React.useState(false);
  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const { control: fcontrol, handleSubmit: fhandleSubmit, errors: ferrors } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });

  const { control: ucontrol, handleSubmit: uhandleSubmit, errors: uerrors, setValue: usetValue } = useForm({
    resolver: yupResolver(updatePasswordSchema),
  });
  const [serverResponseStatuss, setServerResponseStatus] = useState({
    apiCalled: false,
    message: '',
    hasError: false
  });
  //const [passwordModal, setPasswordModal] = useState(false);

  const [loginState, dispatch] = useReducer(reduce, {
    loading: false, isLoggedIn: false,
    showPasswordModal: false, serverResponseStatus: {
      apiCalled: false,
      message: '',
      hasError: false,
      forgotPasswordApi: false
    }, forgotEmailSent: false,
    email: ''
  })

  const { loading, isLoggedIn, showPasswordModal, serverResponseStatus, forgotEmailSent, email } = loginState;

  if (getToken() !== null) {
    return (
      <Redirect to='/dashboard' />
    )
  }

  // console.log(VERSION,getVersion())

  const authenticate = (data) => {
    // console.log(data);
    dispatch({ type: 'api_called', payload: true });
    loginCredentials({ email: data.email, password: data.password },
      (res) => {
        if (res.status === 1) {
          saveToken(res.data.token)
          saveLoggedInUserDetails(res.data)
          saveCompanyDetails(res.data.company)
          saveProfileImageUrl(res.data.profile_img_url);
          saveVersion(VERSION)
          dispatch({ type: 'logged_in' });
        } else {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: res.message, hasError: true } });
          // setServerResponseStatus({apiCalled: true, message: res.errors, hasError: true})
        }
      }, (err) => {
        if (err.response) {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: err.response.data.detail, hasError: true } });
          //setServerResponseStatus({apiCalled: true, message: err.response.data.detail, hasError: true})
        } else if (err.request) {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true } });
          // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
        } else {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true } });
          // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
        }
      });
  }

  const callLoginWithGmailApi = (data) => {
    dispatch({ type: 'api_called', payload: true });
    loginwithGmail(data, (res) => {
      if (res.status === 1) {
        saveToken(res.data.token);
        saveLoggedInUserDetails(res.data);
        saveCompanyDetails(res.data.company)
        saveProfileImageUrl(res.data.profile_img_url);
        saveVersion(VERSION)
        dispatch({ type: 'logged_in' });
      } else {
        dispatch({ type: 'api_error', payload: { apiCalled: true, message: res.message, hasError: true } });
        // setServerResponseStatus({apiCalled: true, message: res.errors, hasError: true})
      }
    }, (err) => {
      if (err.response) {
        dispatch({ type: 'api_error', payload: { apiCalled: true, message: err.response.data.detail, hasError: true } });
        //setServerResponseStatus({apiCalled: true, message: err.response.data.detail, hasError: true})
      } else if (err.request) {
        dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true } });
        // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
      } else {
        dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true } });
        // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
      }
    })
  }

  const callPasswordResetApi = (data) => {
    // console.log(data);
    dispatch({ type: 'api_called', payload: true });
    forgotPassword({ email: data.femail },
      (res) => {
        if (res.result === 1) {
          dispatch({ type: 'forgot_password_email_sent', payload: data.femail })
        } else {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: res.errors, hasError: true, forgotPasswordApi: true } });
          // setServerResponseStatus({apiCalled: true, message: res.errors, hasError: true})
        }
      }, (err) => {
        if (err.response) {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: err.response.data.detail, hasError: true, forgotPasswordApi: true } });
          //setServerResponseStatus({apiCalled: true, message: err.response.data.detail, hasError: true})
        } else if (err.request) {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true, forgotPasswordApi: true } });
          // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
        } else {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true, forgotPasswordApi: true } });
          // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
        }
      });
  }

  const callPasswordUpdateApi = (data) => {
    // console.log(data);
    dispatch({ type: 'api_called', payload: true });
    updatePassword({ email: data.femail, code: data.fotp, password: data.fpassword, retype_new_password: data.fcpassword },
      (res) => {
        if (res.result === 1) {
          dispatch({ type: 'update_password', payload: { apiCalled: true, message: res.message, hasError: false, forgotPasswordApi: false } })
        } else {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: res.errors, hasError: true, forgotPasswordApi: true } });
          // setServerResponseStatus({apiCalled: true, message: res.errors, hasError: true})
        }
      }, (err) => {
        if (err.response) {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: err.response.data.detail, hasError: true, forgotPasswordApi: true } });
          //setServerResponseStatus({apiCalled: true, message: err.response.data.detail, hasError: true})
        } else if (err.request) {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true, forgotPasswordApi: true } });
          // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
        } else {
          dispatch({ type: 'api_error', payload: { apiCalled: true, message: 'Something went wrong!!!', hasError: true, forgotPasswordApi: true } });
          // setServerResponseStatus({apiCalled: true, message: 'Something went wrong!!!', hasError: true})
        }
      });
  }

  const onSuccessGmail = (response) => {
    let token = response.tokenObj.id_token;
    callLoginWithGmailApi({ 'token': token })
  }

  const onError = (response) => {
    console.log(response)
  }


  // console.log(errors, 'validation error');
  // console.log(ferrors, 'validation error');
  // console.log(uerrors, 'validation error');

  // setInterval(function () {
  //   let networkFlag = navigator.onLine;
  //   // console.log(networkFlag);
  //   // setServerResponseStatus({ apiCalled: false });
  //   if (networkFlag === false) {
  //     setServerResponseStatus({ apiCalled: true, message: 'Internet Connection Lost', hasError: true })
  //   }
  // }, 6000);

  return (
    isLoggedIn ? <Redirect to="/dashboard" /> :
      (<>
        <DisplayAlert serverResponseStatus={serverResponseStatuss} />
        {loading && <Loader />}
        <div className="c-app c-default-layout flex-row align-items-center bg-cover">
          <div className="overlay"></div>
          <CContainer>
            <CRow className="justify-content-center">
              <CCol md="6">
                <CCardGroup>
                  <CCard className="p-4 box">
                    <CCardBody>
                      <CForm>
                        <div className="text-center">
                          <img src={yolo_logo} width={'45%'} className='pb-4' />
                          {/* <h1 className="mb-4 login-header">Login</h1> */}
                        </div>

                        {process.env.REACT_APP_ENV == 'DEVELOPMENT' &&
                          <>
                            <CInputGroup className="mb-3">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <CIcon name="cil-user" />
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Controller
                                name="email"
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ onChange, value }) => <CInput id="email" placeholder="Email Id" invalid={errors.email ? true : false} onChange={onChange} value={value} />}
                              />
                              <CInvalidFeedback >
                                {errors.email?.message}
                              </CInvalidFeedback>
                            </CInputGroup>

                            <CInputGroup className="mb-4">
                              <CInputGroupPrepend>
                                <CInputGroupText>
                                  <CIcon name="cil-lock-locked" />
                                </CInputGroupText>
                              </CInputGroupPrepend>
                              <Controller
                                name="password"
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ onChange, value }) => <CInput type="password" id="password" placeholder="Password" invalid={errors.password ? true : false} onChange={onChange} value={value} />}
                              />
                              <CInvalidFeedback >
                                {errors.password?.message}
                              </CInvalidFeedback>
                            </CInputGroup>
                          </>
                        }
                        <CRow>
                          {/* <CCol md="12" className="text-right">
                            <CButton color="link" className="px-0 login-header" onClick={() => dispatch({ type: 'password_modal', payload: true })}>Forgot password?</CButton>
                          </CCol> */}
                          <CCol md="12">
                            {process.env.REACT_APP_ENV == "DEVELOPMENT" && <CButton color="primary" className="px-4 col-12 mb-3" onClick={handleSubmit(authenticate)}>Login</CButton>}
                            <GoogleLogin
                              clientId={gmail_client_id}
                              render={renderProps => (
                                <CButton className="col-12" onClick={renderProps.onClick} color="secondary" disabled={renderProps.disabled}> <img src={`data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=`} /> Sign in with Gmail</CButton>
                              )}
                              buttonText="Login"
                              onSuccess={onSuccessGmail}
                              onFailure={onError}
                              prompt="select_account"
                            />,
                            {/* <CLink to="/center/login">
                        <CButton color="primary" className="px-4 col-12 mb-5" >Center Login</CButton>
                      </CLink> */}
                          </CCol>
                        </CRow>
                      </CForm>
                      {!serverResponseStatus.forgotPasswordApi && <DisplayAlert serverResponseStatus={serverResponseStatus} />}
                    </CCardBody>
                  </CCard>

                </CCardGroup>
              </CCol>
            </CRow>
          </CContainer>

          {
            showPasswordModal && (
              <CModal
                show={showPasswordModal}
                onClose={() => dispatch({ type: 'password_modal', payload: false })}
                closeOnBackdrop={false}
              >
                <CModalHeader closeButton>
                  <CModalTitle>Forgot Password</CModalTitle>
                </CModalHeader>
                <CModalBody>
                  <CForm>
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Controller
                        name="femail"
                        control={(forgotEmailSent) ? ucontrol : fcontrol}
                        defaultValue={(forgotEmailSent) ? email : ''}
                        render={({ onChange, value }) => <CInput id="email"
                          placeholder="Email Id"
                          invalid={(forgotEmailSent) ? (uerrors.femail ? true : false) : (ferrors.femail ? true : false)}
                          onChange={onChange} value={value} readOnly={forgotEmailSent} />}
                      />
                      <CInvalidFeedback >
                        {(forgotEmailSent) ? (uerrors.femail?.message) : (ferrors.femail?.message)}
                      </CInvalidFeedback>

                    </CInputGroup>
                    {
                      forgotEmailSent && (
                        <>
                          <CInputGroup className="mb-3">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <CIcon name="cil-lock-locked" />
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Controller
                              name="fotp"
                              control={ucontrol}
                              defaultValue=""
                              render={({ onChange, value }) => <CInput id="fotp" placeholder="OTP" invalid={uerrors.fotp ? true : false} onChange={onChange} value={value} />}
                            />
                            <CInvalidFeedback >
                              {uerrors.fotp?.message}
                            </CInvalidFeedback>
                          </CInputGroup>
                          <CInputGroup className="mb-3">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <CIcon name="cil-lock-locked" />
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Controller
                              name="fpassword"
                              control={ucontrol}
                              defaultValue=""
                              render={({ onChange, value }) => <CInput type="password" id="fpassword" placeholder="New Password" invalid={uerrors.fpassword ? true : false} onChange={onChange} value={value} />}
                            />
                            <CInvalidFeedback >
                              {uerrors.fpassword?.message}
                            </CInvalidFeedback>

                          </CInputGroup>
                          <CInputGroup className="mb-3">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <CIcon name="cil-lock-locked" />
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Controller
                              name="fcpassword"
                              control={ucontrol}
                              defaultValue=""
                              render={({ onChange, value }) => <CInput type="password" id="fcpassword" placeholder="Confirm New Password" invalid={uerrors.fcpassword ? true : false} onChange={onChange} value={value} />}
                            />
                            <CInvalidFeedback >
                              {uerrors.fcpassword?.message}
                            </CInvalidFeedback>

                          </CInputGroup>
                        </>
                      )
                    }

                  </CForm>
                </CModalBody>
                <CModalFooter>
                  {serverResponseStatus.forgotPasswordApi && <DisplayAlert serverResponseStatus={serverResponseStatus} />}

                  {
                    (forgotEmailSent) ? (<CButton color="primary" onClick={uhandleSubmit(callPasswordUpdateApi)}>Update Password</CButton>) : (<CButton color="primary" onClick={fhandleSubmit(callPasswordResetApi)}>Reset Password</CButton>)
                  }


                </CModalFooter>
              </CModal>
            )
          }

        </div>
      </>)
  )
}

export default Login
